import React from 'react'
//import Breadcrumb from "../components/Breadcrumb";
//import { RevenueReportOne, CustomersStatisticsOne, RecentOrdersOne, TransactionsOne, DistributionMapsOne, TopCustomersOne, TopSellingProductOne, StockReportOne } from "../components/dashboardChild";

const DashboardPage = () => {

  return (
    <>
    {/* <Breadcrumb title='Dealership' /> */}
    <section className="d-flex justify-content-center align-items-center DashboardMobile" style={{ height: "70vh" }}>
        <img src="/assets/images/changan-logo/logo-with-text.png" alt="Logo" style={{ maxWidth: "500px", height: "auto" }} />
      </section>
    {/* <section className="row gy-4">
      <RevenueReportOne />
      <CustomersStatisticsOne />
      <RecentOrdersOne />
      <TransactionsOne />
      <DistributionMapsOne />
      <TopCustomersOne />
      <TopSellingProductOne />
      <StockReportOne />
    </section> */}
</>

  )
}

export default DashboardPage